let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5T70u")).then(() => parcelRequire('9IxpB'));